import { useEffect, useState } from "react"
import { Loader2 } from "lucide-react"
import { apiClient } from "@/lib/api"

export default function DemoEntryPage() {
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    // Seed the fixed demo user (idempotent), then redirect to login with pre-fill
    apiClient.demoLogin().then(res => {
      if (!res.ok) {
        setError(res.error || "Failed to set up demo")
        return
      }
      // Redirect to login page with demo flag — LoginPage will pre-fill and auto-submit
      window.location.href = "/login?demo=true"
    }).catch(() => {
      // Even if seed fails (user might already exist), try redirecting anyway
      window.location.href = "/login?demo=true"
    })
  }, [])

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center space-y-3">
          <p className="text-sm text-destructive">{error}</p>
          <button
            onClick={() => window.location.reload()}
            className="text-xs text-muted-foreground hover:text-primary transition-colors underline"
          >
            Try again
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background gap-4">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
      <p className="text-sm text-muted-foreground">Setting up your demo...</p>
    </div>
  )
}
